export default __webpack_public_path__ + "static/media/bwin_colored.1315a1c7.png";